module.exports = __webpack_public_path__ + "media/common/images/badges/gray/s_plynem_na_podlaze-70d46d8b02b5e043e0832ce4568744e6.svg";